import {
	EnhancedDropDownRHFWithLabel,
	EnhancedIOSSwitchRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { Box } from "@mui/material";
import { FC } from "react";

interface IAdminEarningsInfoSetupFieldsPanel {}

export const payrollEarningsT4Codes = [
//   { label: "14 - Employment Income", value: 14 },
  { label: "30 - Board and lodging", value: 30 },
  { label: "31 - Special work site", value: 31 },
  { label: "32 - Travel in a prescribed zone", value: 32 },
  { label: "33 - Medical travel assistance", value: 33 },
  { label: "34 - Personal use of employer's automobile or motor vehicle", value: 34 },
  { label: "36 - Interest-free and low-interest loans", value: 36 },
  { label: "37 - Employee home-relocation loan deduction", value: 37 },
  { label: "97 - Stock option benefit amount before February 28, 2000", value: 97 },
  { label: "38 - Security options benefits", value: 38 },
  { label: "98 - Stock option and share deduction 110(1) (d) amount before February 28, 2000", value: 98 },
  { label: "39 - Security options deduction - 110(1)(d)", value: 39 },
  { label: "40 - Other taxable allowances and benefits", value: 40 },
  { label: "41 - Security options deduction - 110(1)(d.1)", value: 41 },
  { label: "42 - Employment commissions", value: 42 },
  { label: "43 - Canadian Forces personnel and police deduction", value: 43 },
  { label: "66 - Eligible retiring allowances", value: 66 },
  { label: "67 - Non-eligible retiring allowances", value: 67 },
  { label: "68 - Indian (exempt income) - Eligible retiring allowances", value: 68 },
  { label: "69 - Indian (exempt income) - Non-eligible retiring allowances", value: 69 },
  { label: "70 - Municipal officer's expense allowance", value: 70 },
  { label: "71 - Indian (exempt income) - Employment", value: 71 },
  { label: "72 - Section 122.3 income - Employment outside Canada", value: 72 },
  { label: "73 - Number of days outside Canada", value: 73 },
  { label: "74 - Past service contributions for 1989 or earlier years while a contributor", value: 74 },
  { label: "75 - Past service contributions for 1989 or earlier years while not a contributor", value: 75 },
  { label: "77 - Workers' compensation benefits repaid to the employer", value: 77 },
  { label: "78 - Fishers - Gross income", value: 78 },
  { label: "79 - Fishers - Net partnership amount", value: 79 },
  { label: "80 - Fishers - Shareperson amount", value: 80 },
  { label: "81 - Placement or employment agency workers - Gross income", value: 81 },
  { label: "82 - Taxi drivers and drivers of other passenger-carrying vehicles - Gross income", value: 82 },
  { label: "83 - Barbers or hairdressers - Gross income", value: 83 },
  { label: "84 - Public transit pass", value: 84 },
  { label: "85 - Employee-paid premiums for private health services plans", value: 85 },
  { label: "86 - Security options election", value: 86 },
  { label: "87 - Volunteer firefighter exempt amount", value: 87 },
  { label: "88 - Indian (exempt income) - self-employment", value: 88 },
];

export const payrollEarningsRl1Codes = [
//   { label: "A-Employment Income", value: "A" },
  { label: "F-Cotisation syndicale", value: "F" },
  { label: "J- Régime privé d'ass. maladie", value: "J" },
  { label: "K-Voyages (région éloignée)", value: "K" },
  { label: "L-Autres avantages", value: "L" },
  { label: "M-Commissions", value: "M" },
  { label: "N-Dons de bienfaisance", value: "N" },
  { label: "O-Autres revenus", value: "O" },
  { label: "P- Régime d’ass. interentreprises", value: "P" },
  { label: "Q-Salaires différés", value: "Q" },
  { label: "R-Revenu « situé» dans une réserve'", value: "R" },
  { label: "S- Pourboires reçus", value: "S" },
  { label: "T-Pourboires attribués", value: "T" },
  { label: "U- Retraite progressive", value: "U" },
  { label: "V-Nourriture et logement", value: "V" },
  { label: "W-Véhicule à moteur", value: "W" },
];
export const AdminEarningsInfoSetupFieldsPanel: FC<
	IAdminEarningsInfoSetupFieldsPanel
> = ({}) => {
	return (
		<Box>
			<RHookFormTextFieldWithLabel
				label="Label"
				id="label"
				testId={`label`}
				labelPosition={LabelPosition.Top}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="category"
				items={[
					{label:"Benefit Allowance",value:100},
					{label:"General",value:200},
					{label:"Special Payment",value:300}
				]}
				selectedItem={200}
				testId="category"
				label="Category"
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="t4Code"
				items={payrollEarningsT4Codes}
				testId="t4Code"
				label="T4 Code"
				// showEmpty
			/>
			<EnhancedIOSSwitchRHFWithLabel
				name="excludeFrom14"
				checked={false}
				testId="excludeFrom14"
				label={"Exclude From 14"}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="rl1Code"
				items={payrollEarningsRl1Codes}
				testId="rl1Code"
				label="RL-1 Code"
				// showEmpty
			/>
			<EnhancedIOSSwitchRHFWithLabel
				name="excludeFromA"
				checked={false}
				testId="excludeFromA"
				label={"Exclude From a"}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="type"
				items={[
					{label:"Cash",value:100},
					{label:"Non Cash",value:200}
				]}
				selectedItem={100}
				testId="type"
				label="Type"
			/>
			{/* <EnhancedDropDownRHFWithLabel
				selectName="showIn"
				items={[]}
				testId="showIn"
				label="Show in"
			/> */}
			<EnhancedDropDownRHFWithLabel
				selectName="taxEngine"
				items={[
					{label:"Bonus",value:100},
					{label:"Regular",value:200}
				]}
				selectedItem={200}
				testId="taxEngine"
				label="Tax Engine Regular"
			/>
		</Box>
	);
};
